import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import InventoryTransactions from '../InventoryTransactions';
import { InventoryTransactionsHubProvider } from './InventoryTransactionsHubContext';

const DRAWER_OPEN_PATTERN = /^\/inventory-transactions\/(view\/|invoice\/|bill\/|payment\/)/;

const InventoryTransactionsLayout = () => {
  const { pathname } = useLocation();
  const overlayOpen = DRAWER_OPEN_PATTERN.test(pathname);

  return (
    <InventoryTransactionsHubProvider>
      <div className="h-screen w-full bg-gray-100 flex overflow-hidden">
        <Sidebar />
        <main className="flex-1 flex flex-col min-h-0 overflow-hidden p-4 md:p-6 relative">
          <div
            className={`flex-1 flex flex-col min-h-0${
              overlayOpen ? ' pointer-events-none select-none opacity-60' : ''
            }`}
            aria-hidden={overlayOpen}
          >
            <InventoryTransactions />
          </div>
          <Outlet />
        </main>
      </div>
    </InventoryTransactionsHubProvider>
  );
};

export default InventoryTransactionsLayout;
